import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  cardImage: {
    width: '15.625rem',
    [theme.breakpoints.down('md')]: {
      width: '12.5rem'
    }
  },
  cardImageWrapper: {
    minHeight: '20rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      minHeight: '17rem'
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '15rem'
    },

  },
  cardInfoTextWrapper: {
    marginBottom: '1.5rem'
  },
  cardInfoText: {
    textAlign: 'center'
  },
  secondaryBtnWrapper: {
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  primaryBtnWrapper: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  }
}));
